import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabour = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9.61719C10.3644 9.61719 13.0931 10.3642 13.1143 11.7285C12.2297 13.0588 10.7143 13.9365 9 13.9365C7.2859 13.9364 5.77024 13.0587 4.88574 11.7285C4.90683 10.3643 7.62856 9.61735 9 9.61719Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 4.2002C10.1383 4.2002 11.0576 5.11859 11.0576 6.25684C11.0576 7.39512 10.1383 8.31445 9 8.31445C7.86192 8.31421 6.94336 7.39497 6.94336 6.25684C6.9434 5.11874 7.86195 4.20044 9 4.2002Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 1C13.4183 1 17 4.58172 17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1ZM9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2Z",
			fill: "black"
		})
	]
});
export default SvgLabour;
